"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckboxInputGroup = exports.checkboxInputGroupProps = void 0;
var storm_ui_1 = require("@amzn/storm-ui");
var filter_input_styles_1 = require("./filter_input.styles");
var react_1 = __importDefault(require("react"));
var immutable_1 = require("immutable");
var checkboxInputGroupProps = function (filterInput) { return ({
    onChangeValue: function (option) {
        var selected = filterInput.state.filter.selected;
        filterInput.setState({
            filter: __assign(__assign({}, filterInput.state.filter), { selected: selected.has(option) ? selected.delete(option) : selected.add(option) }),
        });
    },
    onClickRemove: function () {
        filterInput.props.setAppliedFilters(filterInput.state.filter.value, immutable_1.OrderedSet.of());
        filterInput.setState({
            filter: { label: '', value: '', options: immutable_1.OrderedSet.of(), selected: immutable_1.OrderedSet.of() },
            isPopoverOpen: false,
        });
    },
    onClickCancel: function () { return filterInput.setState({ isPopoverOpen: false }); },
    onClickApply: function () {
        filterInput.props.setAppliedFilters(filterInput.state.filter.value, filterInput.state.filter.selected);
        filterInput.setState({
            filter: { label: '', value: '', options: immutable_1.OrderedSet.of(), selected: filterInput.state.filter.selected },
            isPopoverOpen: false,
        });
    },
}); };
exports.checkboxInputGroupProps = checkboxInputGroupProps;
var CheckboxInputGroup = function (props) {
    var selected = props.selected, options = props.options, onChangeValue = props.onChangeValue, inputType = props.inputType, filtersLabel = props.filtersLabel;
    return (react_1.default.createElement(storm_ui_1.UIDConsumer, { value: 'select-filter' }, function (uid) { return (react_1.default.createElement(filter_input_styles_1.PaddedCheckboxGroup, { hideLabel: true, label: filtersLabel }, options
        .map(function (option) {
        return (react_1.default.createElement(storm_ui_1.Checkbox, { key: option.value, id: "uid-".concat(option.value), label: option.label, onChange: function () { return onChangeValue(option, inputType); }, checked: selected.has(option) }));
    })
        .toArray())); }));
};
exports.CheckboxInputGroup = CheckboxInputGroup;
